import React from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Spinner,
  Text,
  useColorModeValue,
  IconButton,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { FaEdit, FaTrash, FaClipboardList, FaPlus } from 'react-icons/fa';
import { listFormsAdmin, deleteFormAdmin } from '../services/formService';

export default function FormBuilder() {
  const textColor = useColorModeValue('gray.800', 'white');
  const cardBg = useColorModeValue('white', 'gray.700');
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery(['admin-forms'], async () => {
    const res = await listFormsAdmin();
    return res.data?.data?.forms || [];
  });

  const delMut = useMutation(deleteFormAdmin, {
    onSuccess: () => {
      queryClient.invalidateQueries(['admin-forms']);
      toast.success('حذف شد');
    },
    onError: (e) => toast.error(e.response?.data?.message || 'خطا در حذف'),
  });

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6} wrap="wrap" gap={3}>
        <Heading size="md" color={textColor}>
          فرم‌ساز
        </Heading>
        <Button
          as={Link}
          to="/form-builder/new"
          leftIcon={<FaPlus />}
          colorScheme="teal"
          borderRadius="15px"
          fontSize="sm"
          fontWeight="bold"
          px="20px"
          py="10px"
        >
          فرم جدید
        </Button>
      </Flex>

      <Box bg={cardBg} borderRadius="xl" p={4} boxShadow="sm" overflowX="auto">
        {isLoading ? (
          <Flex justify="center" py={10}>
            <Spinner />
          </Flex>
        ) : !data?.length ? (
          <Text color="gray.500" textAlign="center" py={8}>
            هنوز فرمی تعریف نشده است.
          </Text>
        ) : (
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>عنوان</Th>
                <Th>وضعیت</Th>
                <Th>تعداد فیلد</Th>
                <Th textAlign="end">عملیات</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((f) => (
                <Tr key={f._id}>
                  <Td fontWeight="medium">{f.title}</Td>
                  <Td>
                    <Badge colorScheme={f.isActive ? 'green' : 'gray'}>
                      {f.isActive ? 'فعال' : 'غیرفعال'}
                    </Badge>
                  </Td>
                  <Td>{(f.fields || []).length}</Td>
                  <Td textAlign="end">
                    <IconButton
                      as={Link}
                      to={`/form-builder/${f._id}/responses`}
                      aria-label="پاسخ‌ها"
                      icon={<FaClipboardList />}
                      size="sm"
                      variant="ghost"
                      me={1}
                    />
                    <IconButton
                      as={Link}
                      to={`/form-builder/${f._id}/edit`}
                      aria-label="ویرایش"
                      icon={<FaEdit />}
                      size="sm"
                      variant="ghost"
                      me={1}
                    />
                    <IconButton
                      aria-label="حذف"
                      icon={<FaTrash />}
                      size="sm"
                      variant="ghost"
                      colorScheme="red"
                      onClick={() => {
                        if (window.confirm('فرم و تمام پاسخ‌هایش حذف شوند؟')) {
                          delMut.mutate(f._id);
                        }
                      }}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </Box>
    </Box>
  );
}
